import React from 'react';
import { Box, Text, Button, VStack } from '@chakra-ui/react';
import webCore from '@happylife-a/web-core';
import webApp from '@happylife-a/web-app';

export default function EmptyState({ onExplorePress }) {
  const { t } = webCore.contexts.useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      px={6}
      py={12}
      textAlign="center"
    >
      <Box
        bg="gray.400"
        borderRadius="full"
        p={3}
        mb={6}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <webApp.theme.icons.ReloadIcon w={6} h={6} />
      </Box>

      <Text fontSize="xl" fontWeight="bold" color="gray.800" mb={3}>
        {t('No Booking History')}
      </Text>

      <Text fontSize="md" color="gray.600" mb={6} lineHeight="short">
        {t('emptyBookingHistoryDescription')}
      </Text>

      <Button
        colorScheme="primary"
        onClick={onExplorePress}
        px={8}
        py={6}
        fontWeight="semibold"
        fontSize="md"
      >
        {t('Explore Now')}
      </Button>
    </Box>
  );
}
